// JS for the index page

import './main';
import './partials/animations';

const axios = require('axios');

document.addEventListener('DOMContentLoaded', function() {
    // --- Contact form ---
    var contactForm = document.querySelector('#contact-form');

    if (contactForm) {
        var formInputs = contactForm.querySelectorAll('#contact-form input,textarea,button');

        formInputs.forEach(input => {
            ['click', 'keypress', 'change'].forEach(evt => {
                input.addEventListener(evt, function() {
                    if (!contactInitTime) contactInitTime = new Date();
                });
            });
        });

        // HP
        setTimeout(function() {
            document.querySelector('#terms').setAttribute('aria-required', 'false');
            document.querySelector('#terms-label').setAttribute('aria-required', 'false');
        }, 5000);

        var contactFormButton = contactForm.querySelector('.send-button');
        var contactInitTime = null;

        contactForm.addEventListener('submit', function (event) {
            event.preventDefault();

            const formAxios = axios.create();
            formAxios.interceptors.request.use(config => {
                formInputs.forEach(elem => {
                    elem.setAttribute('disabled', 'disabled');
                    elem.setAttribute('aria-disabled', true);
                });
                return config;
            });

            var body = new FormData(contactForm);
            body.append('time', new Date() - contactInitTime);

            function updateValidationMessages(data, request) {
                ['name', 'email', 'subject', 'message'].forEach(id => {
                    var input = contactForm.querySelector('#' + id);
                    var errorSpan = input.nextElementSibling;
                    if (data && id in data) {
                        input.setAttribute('aria-invalid', true);
                        input.classList.add('error');
                        errorSpan.innerHTML = request.response.data[id][0];
                    } else {
                        input.setAttribute('aria-invalid', false);
                        input.classList.remove('error');
                        errorSpan.innerHTML = '&nbsp;';
                    }
                });
            }


            formAxios.post(contactForm.getAttribute('action'), body)
                .then(function (request) {
                    updateValidationMessages(null, request);
                    contactFormButton.innerHTML = contactFormButton.dataset.submitMessageSent;
                })
                .catch(function (request) {
                    if(request.response.data) {
                        updateValidationMessages(request.response.data, request);
                        contactFormButton.innerHTML = contactFormButton.dataset.submitMessageFormError;

                        formInputs.forEach(elem => {
                            elem.removeAttribute('disabled');
                            elem.setAttribute('aria-disabled', false);
                        });
                    } else {
                        contactFormButton.innerHTML = contactFormButton.dataset.submitMessageError;
                    }
                });
        });
    }
});
